var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEtherium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9981 4.66702L13.9982 4.66675L19.8298 14.3428L19.8297 14.3429L13.9982 17.7899L13.9981 17.7898V17.7899L8.1665 14.3428L13.9981 4.66675V4.66702ZM13.9981 23.6662L8.16663 15.4487L13.9983 18.894V18.894L19.8333 15.4487L13.9983 23.6664L13.9982 23.6665L13.9981 23.6662Z",
    fill: "#ABABAB"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtherium);
export default __webpack_public_path__ + "static/media/etherium.51c5c583abd0b77ad56a056bed0764cd.svg";
export { ForwardRef as ReactComponent };